export default __webpack_public_path__ + "static/media/Liby.61620f6d.png";